// extracted by mini-css-extract-plugin
export default {"bannerContainer":"styles_bannerContainer__ICKaH","titleImage":"styles_titleImage__CRmGD","bannerImage":"styles_bannerImage__WdoCx","triangle":"styles_triangle__oSDtD"};